import timezoneOptions from './iana_timezones_with_labels.json';
import { addAbbreviationToTimezones } from './utils';

export interface ITimezoneState {
	timezone: string;
	displayName: string;
	abbreviation: string;
}

export interface ITimezoneOption {
	label: string;
	value: string;
	abbreviation: string;
}

// Raw timezone data from JSON
type RawTimezoneData = Array<{
	label: string;
	value: string;
}>;

export const TIMEZONE_OPTIONS: ITimezoneOption[] = addAbbreviationToTimezones(
	timezoneOptions as RawTimezoneData
);
